import React, { useState, useEffect } from "react";
import { Card, Row, Col, InputNumber, Typography } from 'antd';
import { STATE_STATUS } from "constants/index";

const { Text } = Typography;

const percentInputProps = {
    min: 0,
    max: 100,
    parser: (val) => {
        if (!val) return "";
        let num = Number(val.toString().replace(/[^\d]/g, ""));
        if (isNaN(num)) return "";
        return Math.min(100, Math.max(0, num));
    },
    formatter: (val) => (val === null || val === undefined ? "" : String(val)),
};

const BundledLimitAssignment = ({
    caseId,
    childLimit,
    maxTlLimitUtilisationPerc,
    onSave,
    stageId,
    userGroup,
    fetchCaseDetailFields,
    caseDetailFields,
    caseDetailFieldsStatus
}) => {
    const [localLimit, setLocalLimit] = useState(childLimit ?? null);
    const [localMaxTlPerc, setLocalMaxTlPerc] = useState(maxTlLimitUtilisationPerc ?? null);

    useEffect(() => {
        if (caseId && fetchCaseDetailFields) {
            fetchCaseDetailFields(caseId);
        }
    }, [caseId, fetchCaseDetailFields]);

    useEffect(() => {
        setLocalLimit(childLimit ?? null);
    }, [childLimit]);

    useEffect(() => {
        setLocalMaxTlPerc(maxTlLimitUtilisationPerc ?? null);
    }, [maxTlLimitUtilisationPerc]);

    const isCreditManager = userGroup?.some(el => el?.id === 7);
    const hasStageAndGroupAccess = [7, 8].includes(stageId) &&
        userGroup?.some(el => [7, 8].includes(el?.id));
    const fieldsFetched = caseDetailFieldsStatus === STATE_STATUS.FETCHED;
    const childMovedToLms = caseDetailFields?.get?.("child_moved_to_lms") === true;
    // Child Case Limit was previously only group-gated (Credit Manager),
    // editable at ANY stage — added the same [7, 8] credit-stage check
    // Max TL Limit already carries, so it can't be edited outside Credit
    // Appraisal / Re-credit.
    const childLimitEditable =
        isCreditManager &&
        fieldsFetched &&
        !childMovedToLms &&
        [7, 8].includes(stageId);
    const maxTlEditable = hasStageAndGroupAccess;
    const updateEnabled = childLimitEditable || maxTlEditable;

    const onChangeChildLimitFn = (val) => {
        if (val === null) {
            setLocalLimit(null);
            return;
        }
        setLocalLimit(val);
    };

    const onChangeMaxTlPercFn = (val) => {
        if (val === null) {
            setLocalMaxTlPerc(null);
            return;
        }
        setLocalMaxTlPerc(val);
    };
    return (
        <Card title="Bundled Limit Assignment" bordered={false}
            extra={
                [
                    <a
                        className="d-flex align-items-center"
                        key={"icon"}
                        disabled={!updateEnabled}
                        // `disabled` is not a real HTML attribute for <a> —
                        // without gating onClick too, the "disabled" anchor
                        // would still fire and save outside the allowed
                        // stage/group.
                        onClick={
                            updateEnabled
                                ? () =>
                                    onSave({
                                        bundled_limit_percentage: localLimit,
                                        max_tl_limit_utilisation_perc: localMaxTlPerc
                                    })
                                : undefined
                        }
                    >
                        Update
                    </a>
                ]

            }
        >
            <Row gutter={16} align="middle">
                <Col span={8}>
                    <Text strong>Child Case Limit(% of Parent Sanctioned Limit)</Text>
                    <InputNumber
                        {...percentInputProps}
                        value={localLimit}
                        disabled={!childLimitEditable}
                        onChange={onChangeChildLimitFn}
                        style={{ width: '100%' }}
                        placeholder="Enter limit"
                    />
                </Col>
                <Col span={8}>
                    <Text strong>Max TL Limit Utilisation (%)</Text>
                    <InputNumber
                        {...percentInputProps}
                        value={localMaxTlPerc}
                        disabled={!maxTlEditable}
                        onChange={onChangeMaxTlPercFn}
                        style={{ width: '100%' }}
                        placeholder="Enter %"
                    />
                </Col>
            </Row>
        </Card>
    );
};

export default BundledLimitAssignment;
